import React from 'react';
import { UrlRecommendationContent } from '../type';
import { useURLState } from './URL.state';
import { URLView } from './URL.view';

interface URLProps {
    onURLSelect: (content: UrlRecommendationContent) => void;
}

const URL: React.FC<URLProps> = ({ onURLSelect }) => {
    const state = useURLState(onURLSelect);
    return <URLView {...state} />;
};

export default URL;
